import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "router-app"
};
import { onMounted, onBeforeUnmount, computed, nextTick, ref } from 'vue';
import { ElConfigProvider } from 'element-plus';
import NavigatorBar from '@/components/Basic/NavigatorBar.vue';
import { inLoggedType } from "@/tools/utils";
import router from '@/router';
import store from '@/store';
import { Decimal } from 'decimal.js';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
export default {
  __name: 'App',

  setup(__props) {
    Decimal.set({
      precision: 8,
      rounding: Decimal.ROUND_FLOOR
    }); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : null); // refs

    const backImage = ref(null); // functions

    const onScroll = () => {
      if (!backImage.value) return;
      let node = backImage.value; // const logicalHeight = (node.offsetWidth) / 816 * 1456

      const logicalHeight = node.offsetWidth ?? 0;
      const scrollHeight = node.scrollHeight;
      const height = node.offsetHeight;
      const offset = node.scrollTop; // console.log(`scrollHeight=${scrollHeight} logicalHeight=${logicalHeight} offset=${offset}`)

      if (scrollHeight > height) {
        const factor = offset / (scrollHeight - height);
        const logicalOffset = factor * (logicalHeight - height);
        node.style.backgroundPositionY = `-${logicalOffset > offset ? offset : logicalOffset}px`;
      }
    }; // lifecycle


    onMounted(() => {
      let localHeaders = null;
      const value = localStorage.getItem('headers');

      if (value && typeof value === 'string') {
        try {
          localHeaders = JSON.parse(value);

          if (localHeaders) {
            if (!store.state.headers) {
              store.commit('update_headers', localHeaders);
            }
          }
        } catch (e) {
          console.error(e);
          localStorage.removeItem('headers');
        }
      }

      if (store.state.headers) {
        if (!localHeaders) {
          store.commit('delete_user');
          store.commit('update_headers', null);
        } else if (store.state.headers.token !== localHeaders.token) {
          store.commit('update_headers', localHeaders);
        }
      }

      if (!userType.value) router.push('/login');else router.push('/account');
      nextTick(() => {
        if (backImage.value) {
          backImage.value.addEventListener('scroll', onScroll);
        }
      });
    });
    onBeforeUnmount(() => {
      if (backImage.value) {
        backImage.value.removeEventListener('scroll', onScroll);
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("div", {
          id: "mask-container"
        }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          id: "backImage",
          ref_key: "backImage",
          ref: backImage
        }, null, 512), _unref(inLoggedType)(userType.value) ? (_openBlock(), _createBlock(NavigatorBar, {
          key: 0
        })) : _createCommentVNode("", true), _createVNode(_component_router_view)])]),
        _: 1
      }, 8, ["locale"]);
    };
  }

};